import _ from 'lodash';
import {
  isExcludeReasonDetectedOutlier,
  isExcludeReasonNoTicketAttached
} from './cycleTimeUtil';
import { metricNames } from '@linearb/linjs-common';
import {
  DEFAULT_TIME_RANGE_KEY,
  isCustomStagesMetric
} from 'common/constants/metrics';

export const PIE_SIZE = { width: 45, height: 45, line: 8 };

export const TABLE_COLUMNS = {
  NAME: 'branch_name',
  STATE: 'state',
  CONTRIBUTORS: 'contributors',
  PR_ISSUER: 'pr_issuer',
  REPO_NAME: 'repository_name',
  CYCLE_TIME: 'cycle_time',
  TIME_TO_PR: 'time_to_pr',
  TIME_TO_REVIEW: 'time_to_review',
  REVIEW_TIME: 'review_time',
  TIME_TO_PROD: 'time_to_prod',
  COMMIT_COUNT: 'commit_count',
  PR_SIZE: 'pr_size',
  PR_STATE: 'pr_state',
  WORK_BREAKDOWN: 'workBreakdown',
  NEW_WORK: 'newWork',
  REWORK: 'rework',
  REFACTOR: 'refactor',
  ACTIONS: 'actions'
};

const WORK_BREAKDOWN_TABLE_COLUMNS = [
  TABLE_COLUMNS.WORK_BREAKDOWN,
  TABLE_COLUMNS.NEW_WORK,
  TABLE_COLUMNS.REWORK,
  TABLE_COLUMNS.REFACTOR
];

const CYCLE_TIME_TABLE_COLUMNS = [
  TABLE_COLUMNS.CYCLE_TIME,
  TABLE_COLUMNS.TIME_TO_PR,
  TABLE_COLUMNS.TIME_TO_REVIEW,
  TABLE_COLUMNS.REVIEW_TIME,
  TABLE_COLUMNS.TIME_TO_PROD
];

export const DEFAULT_TABLE_COLUMNS = [
  TABLE_COLUMNS.NAME,
  TABLE_COLUMNS.STATE,
  TABLE_COLUMNS.CONTRIBUTORS,
  TABLE_COLUMNS.PR_ISSUER,
  TABLE_COLUMNS.REPO_NAME,
  ...CYCLE_TIME_TABLE_COLUMNS,
  ...WORK_BREAKDOWN_TABLE_COLUMNS,
  TABLE_COLUMNS.COMMIT_COUNT,
  TABLE_COLUMNS.PR_SIZE,
  TABLE_COLUMNS.PR_STATE,
  TABLE_COLUMNS.ACTIONS
];

const METRIC_NAME_TIME_RANGE_MAPPER = {
  [metricNames.CYCLE_TIME]: 'cycle_time_updated',
  [metricNames.TIME_TO_PR]: 'coding_ended',
  [metricNames.TIME_TO_REVIEW]: 'reviewed',
  [metricNames.REVIEW_TIME]: 'merged',
  [metricNames.BRANCH_TIME_TO_APPROVE]: 'merged',
  [metricNames.BRANCH_TIME_TO_MERGE]: 'merged',
  [metricNames.TIME_TO_PROD]: 'released',
  [metricNames.RELEASES_COUNT]: 'released_at',
  [metricNames.ACTIVE_BRANCHES]: 'time_range',
  [metricNames.DONE_BRANCHES]: 'time_range',
  [metricNames.REFACTOR]: 'committed',
  [metricNames.REWORK]: 'committed',
  [metricNames.NEW_WORK]: 'committed'
};

export const stateToChipTypeMap = {
  '-': 'skills',
  initiated: 'chambray',
  'in-review': 'warning',
  merged: 'success',
  closed: 'done',
  draft: 'draft'
};
export const branchStateToChipTypeMap = {
  active: 'primary',
  stale: 'warning',
  deleted: 'error',
  inactive: 'error',
  deployed: 'success',
  draft: 'draft'
};

export const getFilterChipLabelMap = ({ branchMetricsPerPrIssuerEnabled }) => {
  return {
    contributors: branchMetricsPerPrIssuerEnabled ? 'Author' : 'Contributor',
    repositories: 'Repository',
    filtered_teams: 'Team',
    services: 'Service',
    labels: 'PR Label'
  };
};

export const disableCycleTimeExclusionFunctionality = ({ branch }) => {
  const {
    cycle_time_excluded: isCycleTimeExcluded,
    cycle_time_excluded_reason: cycleTimeExclusionReason
  } = branch;
  return (
    isExcludeReasonDetectedOutlier(
      isCycleTimeExcluded,
      cycleTimeExclusionReason
    ) ||
    isExcludeReasonNoTicketAttached(
      isCycleTimeExcluded,
      cycleTimeExclusionReason
    )
  );
};

const formatSearchValueToIntArray = stringValue => {
  return stringValue.split(',').map(item => _.toNumber(item));
};
export const getV3PayloadFromSearch = search => {
  const metricName = search.metric_name;
  const timeRangeKey = isCustomStagesMetric(metricName)
    ? DEFAULT_TIME_RANGE_KEY
    : METRIC_NAME_TIME_RANGE_MAPPER[metricName] || '';
  const timeRangeValue = search[timeRangeKey];
  const [from, to] = timeRangeValue.split(',');
  return {
    time_ranges: [{ before: to, after: from }],
    requested_metrics: [{ name: metricName, agg: 'raw' }],
    ...(search.repositories
      ? {
          repository_ids: formatSearchValueToIntArray(search.repositories)
        }
      : {}),
    ...(search.labels ? { labels: search.labels.split(',') } : {}),
    ...(search.services
      ? { service_ids: formatSearchValueToIntArray(search.services) }
      : {}),
    ...(search.teams
      ? { team_ids: formatSearchValueToIntArray(search.teams) }
      : {}),
    ...(search.contributors
      ? {
          contributor_ids: formatSearchValueToIntArray(search.contributors)
        }
      : {}),
    group_by: 'organization',
    roll_up: 'custom'
  };
};
